import React, { useState, useEffect } from 'react';
import {
  Box,Typography,Card,CardContent,Grid,TextField,Button,MenuItem,Select,InputLabel,FormControl,Alert,Table,
  TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,Divider,
} from '@mui/material';
import QuizIcon from '@mui/icons-material/Quiz';
import TimerIcon from '@mui/icons-material/Timer';
import ScheduleIcon from '@mui/icons-material/Schedule';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BookIcon from '@mui/icons-material/Book';
import TopNav from './Navbar';
import LeftNavbar from './LeftNav';
import Breadcrumb from './BreadCrump';
import ExamDetailsModal from './ExamDetailsModal';



const CreateExam = () => {
  const [courses, setCourses] = useState([]);
  const [exams, setExams] = useState([]);
  const [form, setForm] = useState({
    courseId: '',
    title: '',
    subject: '',
    type: '',
    scheduledAt: '',
    durationHours: '',
    durationMinutes: '',
    invigilationMode: '',
  });
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [selectedExam, setSelectedExam] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

const handleViewClick = (exam) => {
  setSelectedExam(exam);
  setModalOpen(true);
};

const handleModalClose = () => {
  setSelectedExam(null);
  setModalOpen(false);
};


  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch('http://196.216.9.34:5020/api/exams/courses', {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) throw new Error('Failed to fetch courses');

        const data = await response.json();
        setCourses(data);
      } catch (err) {
        console.error('Failed to fetch instructor courses:', err);
        setError('Failed to load courses.');
      }
    };

    const fetchExams = async () => {
      try {
        const response = await fetch('http://196.216.9.34:5020/api/exams/instructor-exams', {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) throw new Error('Failed to fetch exams');

        const data = await response.json();
        setExams(data);
      } catch (err) {
        console.error('Failed to fetch exams:', err);
        setError('Failed to load exams.');
      }
    };

    if (token) {
      fetchCourses();
      fetchExams();
    }
  }, [token, success]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const {
      courseId,
      title,
      subject,
      type,
      scheduledAt,
      durationHours,
      durationMinutes,
      invigilationMode,
    } = form;

    const duration = `${durationHours}:${durationMinutes}`;

    if (
      !courseId ||
      !title ||
      !subject ||
      !type ||
      !scheduledAt ||
      !durationHours ||
      !durationMinutes ||
      !invigilationMode
    ) {
      setError('All fields are required.');
      setSuccess('');
      return;
    }

    try {
      const response = await fetch('http://196.216.9.34:5020/api/exams/instructor-create-exam', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          courseId,
          title,
          subject,
          type,
          scheduledAt,
          duration,
          invigilationMode,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to create exam');
      }

      setSuccess('Exam created successfully!');
      setError('');
      setForm({
        courseId: '',
        title: '',
        subject: '',
        type: '',
        scheduledAt: '',
        durationHours: '',
        durationMinutes: '',
        invigilationMode: '',
      });
    } catch (err) {
      setError(err.message);
      setSuccess('');
      console.error('Exam creation failed:', err);
    }
  };

  const formatDuration = (duration) => {
    const [hh, mm] = duration.split(':');
    return `${parseInt(hh)}h ${parseInt(mm)}m`;
  };

  

  return (
    <Box sx={{ display: 'flex' }}>
      <LeftNavbar />
      <Box sx={{ flexGrow: 1, ml: { lg: '240px' } }}>
        <TopNav />
        <Box sx={{ p: 10, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Breadcrumb currentPage="Create Exam" />
          <Typography variant="h4" fontWeight="bold" sx={{ mb: 4, color: '#ff6600' }}>
            <QuizIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Create Exam
          </Typography>

          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <Card sx={{ p: 4, boxShadow: 3, mb: 4 }}>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Course</InputLabel>
                    <Select
                      name="courseId"
                      value={form.courseId}
                      onChange={handleChange}
                      label="Course"
                    >
                      {courses.map((course) => (
                        <MenuItem key={course.id} value={course.id}>
                          {course.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField fullWidth label="Exam Title" name="title" value={form.title} onChange={handleChange} />
                </Grid>

                <Grid item xs={12}>
                  <TextField fullWidth label="Subject" name="subject" value={form.subject} onChange={handleChange} />
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Exam Type</InputLabel>
                    <Select name="type" value={form.type} onChange={handleChange} label="Exam Type">
                      <MenuItem value="MCQ">MCQ</MenuItem>
                      <MenuItem value="Essay">Essay</MenuItem>
                      <MenuItem value="Mixed">Mixed</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="datetime-local"
                    name="scheduledAt"
                    label="Schedule"
                    InputLabelProps={{ shrink: true }}
                    value={form.scheduledAt}
                    onChange={handleChange}
                  />
                </Grid>

                {/* Duration Dropdowns */}
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>Hours</InputLabel>
                    <Select
                      name="durationHours"
                      value={form.durationHours}
                      onChange={handleChange}
                      label="Hours"
                    >
                      {[...Array(6)].map((_, i) => (
                        <MenuItem key={i} value={String(i).padStart(2, '0')}>
                          {i} hour{i !== 1 ? 's' : ''}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel>Minutes</InputLabel>
                    <Select
                      name="durationMinutes"
                      value={form.durationMinutes}
                      onChange={handleChange}
                      label="Minutes"
                    >
                      {[0, 15, 30, 45].map((m) => (
                        <MenuItem key={m} value={String(m).padStart(2, '0')}>
                          {m} min
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel>Invigilation Mode</InputLabel>
                    <Select
                      name="invigilationMode"
                      value={form.invigilationMode}
                      onChange={handleChange}
                      label="Invigilation Mode"
                    >
                      <MenuItem value="Manual">Manual</MenuItem>
                      <MenuItem value="Automated">Automated</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    sx={{ bgcolor: '#ff6600', '&:hover': { bgcolor: '#e65c00' } }}
                  >
                    Create Exam
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          {/* Exams Table */}
          <Typography variant="h5" sx={{ mb: 2 }}>
            <VisibilityIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
            Your Exams
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ bgcolor: '#ffe0cc' }}>
                <TableRow>
                  <TableCell><QuizIcon fontSize="small" sx={{ mr: 1 }} />Title</TableCell>
                  <TableCell><BookIcon fontSize="small" sx={{ mr: 1 }} />Subject</TableCell>
                  <TableCell><ScheduleIcon fontSize="small" sx={{ mr: 1 }} />Scheduled At</TableCell>
                  <TableCell><TimerIcon fontSize="small" sx={{ mr: 1 }} />Duration</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Invigilation</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {exams.map((exam) => (
                  <TableRow key={exam.id}>
                  <TableCell>{exam.title}</TableCell>
                  <TableCell>{exam.subject}</TableCell>
                  <TableCell>{new Date(exam.scheduledAt).toLocaleString()}</TableCell>
                  <TableCell>{formatDuration(exam.duration)}</TableCell>
                  <TableCell>{exam.type}</TableCell>
                  <TableCell>{exam.invigilationMode}</TableCell>
                  <TableCell>
                    {exam.status}
                    <Button
                      onClick={() => handleViewClick(exam)}
                      sx={{ ml: 2, minWidth: 'auto', color: '#ff6600' }}
                    >
                      <VisibilityIcon />
                    </Button>
                  </TableCell>
                </TableRow>
                
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
      <ExamDetailsModal
        open={modalOpen}
        handleClose={handleModalClose}
        exam={selectedExam}
        />

    </Box>
  );
};

export default CreateExam;